<div class="p-grid" id="mu-auth-verify-code">
  <h1 class="mu-layout-auth-title p-col-12" innerHTML="{{ 'context.verifyCode.title' | translate }}"></h1>
  <h2
    class="mu-layout-auth-sub-title p-col-12"
    innerHTML="{{ 'context.verifyCode.subTitle' | translate: { code: indicative, number: numberPhoneFormat } }}"
  ></h2>
  <h3
    class="mu-layout-auth-sub-title p-col-12"
    innerHTML="{{ 'context.verifyCode.change' | translate }}"
    (click)="changePhoneNumber()"
  ></h3>
  <div class="p-col-12 mu-without-padding">
    <app-auth-verify-code-form
      [formData]="verifyCodeform"
      [formInputs]="formInput"
      [enabledButton]="enabledButtonResend"
      [showLoginLoading]="showLoginLoading"
      [showLoginLoadingSms]="showLoginLoadingSms"
      [showErrorCode]="showErrorCode"
      [actionList]="actionList"
      [verifyCodeAction]="actionListEnum.VERIFY_CODE"
      [resendVerifyCodeAction]="actionListEnum.RESEND_VERIFY_CODE"
    >
    </app-auth-verify-code-form>
  </div>
  <div class="p-col-12 mu-without-padding">
    <div class="p-grid mu-auth-countdown" *ngIf="!enabledButtonResend">
      <div class="p-col">
        {{ 'context.verifyCode.resendCode' | translate }}
      </div>
      <div class="p-col">{{ seconds }} {{ 'context.verifyCode.seconds' | translate }}</div>
    </div>
  </div>
</div>
